import type { ObjectId } from "@bbj-types/utils";
import { useStableCallback } from "@root/utils/hooks/useStableCallback";
import { axios } from "../../axios";
import type { TPostCandidateFetchBody } from "./types";

export interface IPostCandidatesFetchNames {
  _id: ObjectId;
  firstName: string;
  lastName: string;
}

export const usePostCandidatesFetchNames = () => {
  const [state, execute, cancel] = axios<IPostCandidatesFetchNames[], TPostCandidateFetchBody, unknown>(
    {
      url: "/candidates/fetch/names",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useStableCallback((candidateIds: ObjectId[]) => {
    return execute({
      data: {
        candidateIds,
      },
    });
  });

  return [state, callback, cancel] as const;
};
